// extracted by mini-css-extract-plugin
export default {"main":"TreasuryPage_main__6gzxE","title":"TreasuryPage_title__Z+eYL","tabs":"TreasuryPage_tabs__KTi6i"};